import type { ActionItem } from "@slfinrtl/ui-bff-routes"
import type { JSX } from "react"
import { useDealerAppRoutes } from "src/common/routes/useDealerAppRoutes"
import type { HoverableFlyoutMenuProps } from "src/components"
import { trackEvent } from "src/components/adobeAnalytics"
import { useModal } from "src/context/modal/useModal"
import { MenuItem } from "./MenuItem"
import type { PrintExposeModalContainerProps } from "./modals/printExposeModal/PrintExposeModalContainer"
import { PrintExposeModalContainer } from "./modals/printExposeModal/PrintExposeModalContainer"
import type { MenuSection as NullableMenuSection } from "./types/MenuSection"

type StrictMenuSection = JSX.Element[]

interface DeliveredVehicleActionMenuView {
	details?: ActionItem
	printVehicleExpose?: ActionItem
}

export const useDeliveredVehicleActionMenu = (
	vehicleKey: string,
	actionMenu: DeliveredVehicleActionMenuView,
): HoverableFlyoutMenuProps["menu"] => {
	const showExposeModal = useModal<PrintExposeModalContainerProps>(PrintExposeModalContainer)
	const routes = useDealerAppRoutes()

	const menu: NullableMenuSection[] = [
		[
			actionMenu.details && routes?.deliveredVehiclesList?.vehicleDetails ? (
				<MenuItem
					key="detailVehicle"
					route={{
						to: routes.deliveredVehiclesList.vehicleDetails.url(vehicleKey),
					}}
					{...actionMenu.details}
				/>
			) : null,
		],
		[
			actionMenu.printVehicleExpose ? (
				<MenuItem
					key="printExpose"
					onClick={() => {
						showExposeModal({ vehicleKey })
						trackEvent({ action: "print_vehicle_expose", category: "delivered_vehicles_action_menu" })
					}}
					{...actionMenu.printVehicleExpose}
				/>
			) : null,
		],
	]

	return menu.map(removeNull).filter(hasItems)
}

const removeNull = (section: NullableMenuSection): StrictMenuSection => section.filter((item) => item !== null)

const hasItems = (section: NullableMenuSection): boolean => section.length > 0
